import { render, staticRenderFns } from "./CreateAnnouncement.vue?vue&type=template&id=2cbdf3ea&"
import script from "./CreateAnnouncement.vue?vue&type=script&lang=js&"
export * from "./CreateAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./CreateAnnouncement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports